export class ProductItemFilters {
    ItemIds: string
    SalesChannelId:number
    PriceConcessionId: string;
}